export const universalQualityPrinciple = `Yleinen laatuperiaate:
Lopputuloksen pitää tuntua aidolta, luonnolliselta, uskottavalta ja käytännönläheiseltä. Vältä ylisiloteltua, liian täydellistä, geneeristä tai tekoälymäistä lopputulosta. Lisää tarvittaessa luonnollisia yksityiskohtia, arkisuutta, inhimillistä epätäydellisyyttä, realistista rytmiä ja kevyttä rosoisuutta.`;

export const universalTextRestrictions = [
  "älä käytä liian mainosmaista tai korporaatiomaista kieltä",
  "älä kuulosta tekoälyltä",
  "älä tee lopputuloksesta liian kiillotettua tai geneeristä",
  "vältä vaikeaa ammattijargonia ja liian pitkiä lauseita",
  "vältä liiallisia superlatiiveja ja täydellistä mainosääntä",
];

export const universalVisualRestrictions = [
  "avoid plastic-looking skin, over-smoothed faces and unrealistic beauty retouching",
  "avoid distorted hands, eyes, hair, teeth, facial expressions and body proportions",
  "avoid an overly polished AI look, fake studio perfection and unrealistic details",
  "avoid changing identity, recognizable features, clothing, product shape or important background details",
  "avoid flicker, morphing, extra limbs, text artifacts, logo distortion and unrealistic motion",
];

export const categoryPromptBlueprints = {
  somepostaus: {
    label: "Somepostaus",
    role: "Toimi kokeneena suomenkielisenä somekirjoittajana ja sisältöstrategina.",
    goal: (f) => `Kirjoita ${f.length} mittainen somepostaus aiheesta ${f.topic}. Postauksen tavoitteena on ${f.goal}.`,
    structure: "Rakenna postaus näin: 1) luonnollinen ja uteliaisuutta herättävä aloitus, 2) samaistuttava tilanne tai ongelma, 3) 3–5 konkreettista pointtia, 4) pieni käytännön esimerkki, 5) pehmeä CTA.",
    format: "Kirjoita valmis julkaisuteksti. Lisää lopuksi 3 vaihtoehtoista aloituslausetta ja 3 CTA-vaihtoehtoa.",
    outcome: "Tuota suoraan julkaisuun sopiva somepostaus, joka kuulostaa ihmiseltä eikä tekoälyn kirjoittamalta.",
  },
  reels: {
    label: "Somevideon käsikirjoitus",
    role: "Toimi kokeneena somevideoiden käsikirjoittajana ja käytännönläheisenä sisältövalmentajana.",
    goal: (f) => `Luo ${f.length} mittainen ${f.channel}-video aiheesta ${f.topic}. Videon tavoitteena on ${f.goal}.`,
    structure: "Rakenna video näin: 1) vahva koukku eli pysäyttävä aloitus, 2) samaistuttava ongelma, 3) käytännönläheinen ratkaisu, 4) hyöty katsojalle, 5) selkeä CTA.",
    format: "Kirjoita valmis kameralle puhuttava käsikirjoitus puhekielellä. Jaa vastaus kohtauksiin ja lisää ruudulle tulevat tekstit, puherepliikit, kuvausvinkki, 3 vaihtoehtoista koukkua ja yksi lyhyt kuvateksti.",
    outcome: "Tuota käsikirjoitus, jonka aloittelija voi kuvata ilman monimutkaista tuotantoa.",
  },
  "ai-kuva": {
    label: "AI-kuvaprompti",
    role: "Toimi kokeneena AI-kuvien promptisuunnittelijana ja realistisen visuaalisen sisällön asiantuntijana.",
    goal: (f) => `Luo realistinen AI-kuvaprompti aiheesta ${f.topic} kanavaan ${f.channel}. Tavoitteena on ${f.goal}.`,
    structure: "Sisällytä pääkohde, ympäristö, valo, kameratyyli, kuvakulma, tunnelma, realistiset yksityiskohdat, luonnolliset epätäydellisyydet ja vältettävät asiat.",
    format: "Kirjoita valmis kuvaprompti suomeksi. Pidä se selkeänä, konkreettisena ja suoraan käytettävänä.",
    outcome: "Tuota realistinen kuvaprompti, jossa painottuvat luonnolliset kasvot, ihon tekstuuri, kädet, valo, mittakaava ja aidon valokuvan tuntu.",
  },
  "ai-video": {
    label: "AI-videoprompti",
    role: "Toimi kokeneena AI-videopromptien suunnittelijana ja realistisen liikkeen, kameratyylin ja kuvakerronnan asiantuntijana.",
    goal: (f) => `Luo AI-videoprompti aiheesta ${f.topic}. Tavoitteena on ${f.goal}.`,
    structure: "Sisällytä aloitustilanne, päätoiminta, kameran liike, kohteen liike, ilme, valaistus, tunnelma, realismi ja asiat, joita ei saa muuttaa.",
    format: "Kirjoita valmis videoprompti suomeksi. Käytä lyhyitä, selkeitä ohjeita ja lisää vältettävät asiat.",
    outcome: "Tuota realistinen videoprompti, joka säilyttää identiteetin ja tärkeät yksityiskohdat samalla kun se lisää uskottavan liikkeen.",
  },
  ugc: {
    label: "UGC-videon käsikirjoitus",
    role: "Toimi kokeneena UGC-sisällöntuotannon käsikirjoittajana ja aidon asiakaskokemuksen sanoittajana.",
    goal: (f) => `Luo ${f.length} mittainen UGC-videon käsikirjoitus aiheesta ${f.topic}. Tavoitteena on ${f.goal}.`,
    structure: "Rakenna video näin: 1) arkinen alku, 2) aito ongelma, 3) miten ratkaisu löytyi, 4) konkreettinen hyöty, 5) rehellinen huomio, 6) luonnollinen suositus tai CTA.",
    format: "Kirjoita kameralle puhuttava käsikirjoitus puhekielellä. Lisää myös kuvausympäristö, eleet, tauot ja ruudulle tulevat tekstit.",
    outcome: "Tuota UGC-käsikirjoitus, joka kuulostaa oikealta ihmiseltä eikä mainokselta.",
  },
  mainos: {
    label: "Mainosteksti",
    role: "Toimi kokeneena suomenkielisenä mainoskirjoittajana ja konversiokeskeisenä sisällöntuottajana.",
    goal: (f) => `Kirjoita mainosteksti aiheesta ${f.topic}. Mainoksen tavoitteena on ${f.goal}.`,
    structure: "Rakenna teksti näin: 1) tunnistettava tilanne, 2) ongelma tai tarve, 3) käytännön hyöty, 4) kevyt todiste tai perustelu, 5) selkeä CTA.",
    format: "Anna 3 otsikkovaihtoehtoa, 2 lyhyttä leipätekstiversiota ja 5 CTA-vaihtoehtoa eri voimakkuuksilla.",
    outcome: "Tuota mainosteksti, joka tuntuu hyödylliseltä ja inhimilliseltä, ei tyrkyttävältä.",
  },
  sahkoposti: {
    label: "Sähköpostiteksti",
    role: "Toimi kokeneena suomenkielisenä viestinnän kirjoittajana.",
    goal: (f) => `Kirjoita sähköposti aiheesta ${f.topic}. Sähköpostin tavoitteena on ${f.goal}.`,
    structure: "Rakenna viesti näin: 1) luonnollinen aiherivi, 2) lyhyt samaistuttava alku, 3) yksi selkeä pääajatus, 4) käytännön hyöty, 5) selkeä mutta pehmeä CTA.",
    format: "Anna 5 aiheriviä, valmis sähköpostiteksti ja yksi lyhyempi versio kiireiselle lukijalle.",
    outcome: "Tuota sähköposti, joka kuulostaa henkilöltä henkilölle kirjoitetulta.",
  },
  myyntisivu: {
    label: "Myyntisivun tekstiosio",
    role: "Toimi kokeneena suomenkielisenä myyntitekstien kirjoittajana ja konversio-optimoinnin asiantuntijana.",
    goal: (f) => `Kirjoita myyntisivun tekstiosio aiheesta ${f.topic}. Osion tavoitteena on ${f.goal}.`,
    structure: "Rakenna osio näin: 1) otsikko, 2) nykyinen haaste, 3) miksi se tuntuu turhauttavalta, 4) ratkaisu, 5) konkreettiset hyödyt, 6) siirtymä seuraavaan osioon.",
    format: "Kirjoita valmis sivustoteksti väliotsikoilla ja lyhyillä kappaleilla.",
    outcome: "Tuota myyntisivun osio, joka auttaa lukijaa tunnistamaan tilanteensa ja etenemään luontevasti.",
  },
  sisaltoidea: {
    label: "Sisältöidea",
    role: "Toimi sisältöstrategina, joka muuttaa yhden aiheen käytännöllisiksi ja helposti toteutettaviksi ideoiksi.",
    goal: (f) => `Luo sisältöideoita aiheesta ${f.topic}. Ideoiden tavoitteena on ${f.goal}.`,
    structure: "Jaa ideat kategorioihin: opettava, samaistuttava, keskustelua herättävä, myyvä ja henkilökohtainen.",
    format: "Anna 20 ideaa taulukkona: idea, kanava, koukku eli pysäyttävä aloitus, näkökulma, toteutustapa ja miksi se toimii.",
    outcome: "Tuota ideat, jotka tuntuvat realistisilta toteuttaa arjessa eikä vain teoriassa hyviltä.",
  },
  hookit: {
    label: "Koukkuideat",
    role: "Toimi lyhytvideoiden ja somejulkaisujen koukkuvalmentajana, joka kirjoittaa uteliaisuutta herättävästi ilman klikkiotsikointia.",
    goal: (f) => `Luo koukkuideoita eli pysäyttäviä aloituksia aiheesta ${f.topic}. Koukkujen tavoitteena on ${f.goal}.`,
    structure: "Luo koukkuja eri kulmista: samaistuminen, virhe, myytti, nopea hyöty, tarina, kysymys ja yllättävä havainto.",
    format: "Anna 25 koukkua taulukkona. Lisää jokaiselle lyhyt käyttövinkki ja arvio siitä, mihin kanavaan se sopii.",
    outcome: "Tuota koukkuja, jotka kuulostavat luonnollisilta ihmiseltä eivätkä liian rakennetuilta.",
  },
  cta: {
    label: "CTA-ideat",
    role: "Toimi konversiokirjoittajana, joka tekee toimintakehotuksista selkeitä, pehmeitä ja tilanteeseen sopivia.",
    goal: (f) => `Luo CTA-ideoita aiheeseen ${f.topic}. CTA:n tavoitteena on ${f.goal}.`,
    structure: "Jaa CTA:t sävyihin: pehmeä, keskusteleva, suora, yhteisöllinen, myyvä ja matalan kynnyksen seuraava askel.",
    format: "Anna 30 CTA-vaihtoehtoa taulukkona: CTA, sävy, missä käyttää ja miksi se toimii.",
    outcome: "Tuota CTA:t, jotka auttavat käyttäjää toimimaan ilman painostavaa myyntifiilistä.",
  },
};